import React, { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { BRAND } from "../lib/i18n";
import { WhatsAppIcon } from "./Header";

const FloatingContact = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-40" data-testid="floating-contact">

      {open && (
        <div
          className="flex flex-col gap-3 mb-3 items-end"
          data-testid="floating-contact-options"
        >
          <a
            href={BRAND.whatsappUrl}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 bg-[#141414] border border-[color:var(--hd-gold)]/30 rounded-full pl-4 pr-2 py-2 text-white hover:border-[color:var(--hd-gold)] transition-all group"
            data-testid="floating-whatsapp"
          >
            <span className="font-body text-sm">WhatsApp</span>
            <span className="w-10 h-10 rounded-full bg-[#25D366] flex items-center justify-center text-white">
              <WhatsAppIcon width={20} height={20} />
            </span>
          </a>
          <a
            href={`tel:${BRAND.phone.replace(/\s+/g, "")}`}
            className="flex items-center gap-3 bg-[#141414] border border-[color:var(--hd-gold)]/30 rounded-full pl-4 pr-2 py-2 text-white hover:border-[color:var(--hd-gold)] transition-all"
            data-testid="floating-call"
          >
            <span className="font-body text-sm">Anrufen</span>
            <span className="w-10 h-10 rounded-full bg-[color:var(--hd-gold)] flex items-center justify-center text-black">
              <MessageCircle size={20} />
            </span>
          </a>
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        className={`w-16 h-16 rounded-full flex items-center justify-center shadow-2xl transition-all ${
          open
            ? "bg-[#141414] border border-[color:var(--hd-gold)] text-[color:var(--hd-gold)]"
            : "bg-[color:var(--hd-gold)] text-black pulse-gold"
        }`}
        data-testid="floating-toggle"
        aria-label="Quick contact"
      >
        {open ? <X size={28} /> : <MessageCircle size={28} />}
      </button>
    </div>
  );
};

export default FloatingContact;
